// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"797e2f511af033ce8540","655":"432a240b4e86f8ed4510"}[chunkId] + ".js";
};